import type { ILink, IRelatedModule } from '@platform/core/types';
import { relatedKeyOf } from './relatedKeyOf';

/**
 * Секції «Пов’язані записи» (прототип RELATED_DEFS): на кожну секцію визначення — його зв'язки (усіх типів, у порядку API), до `limit`
 * для показу й кількість решти («+N ще…»). Зв'язки секції — лише з типом запису її ключа (прототип: l.mod === mk; записи інших типів
 * того самого модуля, напр. голосування в модулі засідань, у секцію не потрапляють); типи з `skip` (підтаблиці «Подробиці») пропускаються. Секції одного модуля з різними підписами
 * (CRM «Акаунти» й «Контакти» з фільтром ролі) — окремі; повтор тієї самої пари модуль+підпис пропускається. Чиста функція.
 */
export function relatedGroups(related: readonly IRelatedModule[], links: readonly ILink[], limit = 5, skip: ReadonlySet<string> = new Set()) {
  const matches = (l: ILink, key: string) => l.otherRecordType === key;
  return related.filter((r, i) => !skip.has(r.module) && related.findIndex((x) => relatedKeyOf(x) === relatedKeyOf(r)) === i).map((r) => {
    const items = links.filter((l) => matches(l, r.module));
    return { key: relatedKeyOf(r), related: r, items: items.slice(0, limit), total: items.length, more: Math.max(0, items.length - limit) };
  });
}
